import React from 'react';


import { Modal, Table } from 'antd';
import { formatPoint } from 'app/shared/util/percent';

type IOtherCommentProps = {
    isOpen: boolean;
    onClose: () => void;
    data: any;
    isLoading: boolean;
};

export const OtherCommentComponent = ({ isOpen, onClose, data, isLoading }: IOtherCommentProps) => {
    const columns = [
        {
            title: <span className='fw-bold'>Người ý kiến</span>,
            key: 'userName',
            width: 250,
            render: item => item?.evaluatePerformerName ? `${item?.evaluateLevelName} - ${item?.evaluatePerformerName}` : item?.evaluateLevelName
        },
        {
            title: <span className='fw-bold'>Điểm ĐG</span>,
            key: 'point',
            width: 120,
            dataIndex: 'point',
            render: item => item ? `${formatPoint(item)}%` : undefined,
        },
        {
            title: <span className='fw-bold'>Ý kiến</span>,
            key: 'feedbackContent',
            width: 250,
            dataIndex: 'feedbackContent',
        },
    ]
    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={onClose} width={'50vw'} className='view'>
            <Table columns={columns} dataSource={data?.map(x => ({
                key: x.versionName,
                evaluateLevelName: x.versionName,
                children: x.evaluateFeedbackItems?.map(item => ({ ...item, key: item.evaluatePerformerName }))
            }))} loading={isLoading} pagination={false} />
        </Modal>
    );
};

export default OtherCommentComponent;
